<template>
    <div>
        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>租户列表</b></p>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                <el-button round @click="permissionClick">导入权限</el-button>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                <el-button round @click="menuClick" type="primary">会员菜单</el-button>
                <span>-</span>
            </p>
        </div>

        <el-table :data="tenantList" style="width: 100%" @select="selectClick" @row-click="rowClick" ref="productTable"
            highlight-current-row>
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>
            <el-table-column type="index" width="40">
            </el-table-column>

            <el-table-column prop="companyName" label="租户" min-width="25%">
            </el-table-column>
            <el-table-column prop="username" label="用户" min-width="20%">
            </el-table-column>
            <el-table-column prop="phone" label="注塑号" min-width="15%">
            </el-table-column>

            <el-table-column prop="createdTime" label="创建日期" min-width="14%">
            </el-table-column>

            <el-table-column prop="expireTime" label="有效期" min-width="16%">
                <template slot-scope="scope">
                    <el-tag size='mini' v-if="scope.row.etTag" type="danger">已过期</el-tag>
                    <span>{{ scope.row.expireTimeStr }}</span>
                </template>
            </el-table-column>

            <el-table-column prop="status" label="状态" min-width="10%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" round size="small">
                        编辑
                    </el-button>
                    <el-button @click="deleteClick(scope.row)" type="warning" round size="small">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <!-- <div>
            <el-pagination background :page-size="10" :page-count="pageCount" layout="prev, pager, next" :total="total"
                @current-change="pageClick" hide-on-single-page>
            </el-pagination>
        </div> -->

        <el-dialog title="租户详情" :visible.sync="dlgFormVisible" width="60%">
            <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">
                <el-form-item label="租户" required :label-width="formLabelWidth">
                    <el-input v-model="form.companyName" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>

                <el-form-item label="用户" required :label-width="formLabelWidth" prop="username">
                    <el-input v-model="form.username" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>

                <el-form-item label="注塑号" required :label-width="formLabelWidth" prop="phone">
                    <el-input v-model="form.phone" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>

                <el-form-item label="创建日期" required :label-width="formLabelWidth" prop="createdTime">
                    <el-date-picker v-model="form.createdTime" type="date" placeholder="选择日期" disabled>
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="有效期" required :label-width="formLabelWidth" prop="expireTime">
                    <el-date-picker v-model="form.expireTime" type="date" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="员工数" required :label-width="formLabelWidth" prop="employeeCount">
                    <el-input-number v-model="form.employeeCount" :step="1" :min="1"
                        style="width:220px"></el-input-number>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dlgFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="$event => editCompany('ruleForm')">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="菜单绑定" :visible.sync="dlgTableVisible">
            <el-table :data="menuList">
                <el-table-column property="menuName" label="菜单" width="100%"></el-table-column>

                <el-table-column fixed="right" label="操作" width="110">
                    <template slot-scope="scope">
                        <el-button @click="bindOrNoClick(scope.row)" type="text" size="small" style="color:green">
                            {{ scope.row.isBind == 0 ? '绑定' : '取消绑定' }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "TenantAdmin",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),

            tenantList: [],
            dlgFormVisible: false,
            dlgTableVisible: false,

            menuList: [{
                menuEName: 'kanbanMenu',
                menuName: '看板管理',
                isBind: 0
            }, {
                menuEName: 'baseInfoMenu',
                menuName: '基础资料',
                isBind: 0
            }, {
                menuEName: 'orderMenu',
                menuName: '订单管理',
                isBind: 0
            }, {
                menuEName: 'productionMenu',
                menuName: '生产管理',
                isBind: 0
            }, {
                menuEName: 'reckonMenu',
                menuName: '计件管理',
                isBind: 0
            }, {
                menuEName: 'qualityMenu',
                menuName: '品质管控',
                isBind: 0
            }, {
                menuEName: 'warehouseMenu',
                menuName: '仓库管理',
                isBind: 0
            }, {
                menuEName: 'reportMenu',
                menuName: '报表管理',
                isBind: 0
            }, {
                menuEName: 'factoryMenu',
                menuName: '工厂管理',
                isBind: 0
            }],

            opCompanyId: '',

            form: {
                id: '',
                companyName: '大公司',
                username: '老板',
                phone: '18888888888',

                createdTime: new Date(),
                expireTime: '',
                status: 0,
                employeeCount: 3
            },

            formLabelWidth: '120px',

            rules: {
                expireTime: [
                    { required: true, message: '请选择有效期', trigger: 'blur' },
                    { required: true, message: '请选择有效期', trigger: 'change' }
                ]
            },
            // pageIndex:0,
            // total: 0,
            // pageCount: 0
        }
    },
    methods: {
        selectClick(selection, row) {
            this.rowClick(row)
        },
        rowClick(row) {

            this.$refs.productTable.clearSelection()
            this.$refs.productTable.toggleRowSelection(row)

            this.opCompanyId = row.id
        },
        getMenu() {
            this.$axios({
                method: "post",
                url: "/shiro/menu/get",
                data: {
                    companyId: this.opCompanyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                const menuArr = ['kanbanMenu', 'baseInfoMenu', 'orderMenu',
                    'productionMenu', 'reckonMenu', 'qualityMenu', 'warehouseMenu', 'reportMenu', 'factoryMenu']

                for (var i = 0; i < 9; i++) {
                    // console.log(data.data[menuArr[i]])

                    this.menuList[i].isBind = data.data[menuArr[i]]
                }

            })
        },
        menuClick(row) {

            if (this.opCompanyId == '') {
                this.$message({
                    type: 'info',
                    message: '请选择租户'
                })
                return
            }

            this.dlgTableVisible = true

            this.getMenu()
        },
        bindOrNoClick(row) {
            const form = new FormData()

            form.append('companyId', this.opCompanyId)
            form.append(row.menuEName, row.isBind == 0 ? 1 : 0)

            this.$axios({
                method: "post",
                url: "/shiro/menu/modify",
                data: form,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.getMenu()
            })
        },
        handleClick(row) {
            // console.log(row)

            this.form.id = row.id

            this.form.companyName = row.companyName
            this.form.username = row.username
            this.form.phone = row.phone

            this.form.createdTime = row.createdTime
            this.form.expireTime = row.expireTime
            this.form.status = null

            this.form.employeeCount = row.employeeCount

            this.dlgFormVisible = true
        },
        deleteClick(row) {
            this.$confirm('确定要删除该租户吗？可能造成无法挽回的损失！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removeCompany(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                })
            })
        },
        removeCompany(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/company/remove",
                data: {
                    id: row.id
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.getAll()
            })
        },
        editCompany(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert('submit!')

                    this.$axios({
                        method: "post",
                        url: "/shiro/company/modify",
                        data: {
                            id: this.form.id,
                            expireTime: this.form.expireTime,
                            employeeCount: this.form.employeeCount
                        }, headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        this.$message(data.msg)

                        this.dlgFormVisible = false

                        this.getAll()
                    })
                } else {
                    // console.log('error submit!!')
                    return false
                }
            })

        },
        getAll() {

            const formData = new FormData()

            formData.append('id', this.companyId)

            this.$axios({
                method: "post",
                url: "/shiro/company/tenant",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status == 400 || data.status == 401) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })

                    this.$router.push({ path: "/Login" })
                }

                this.tenantList = data.data

                for (let i in this.tenantList) {
                    this.tenantList[i].createdTime = this.$moment(this.tenantList[i].createdTime).format("YYYY-MM-DD")

                    var etStr = this.$moment(this.tenantList[i].expireTime).format("YYYY-MM-DD HH:mm")
                    var et = new Date(etStr)

                    if (et < new Date()) {
                        this.tenantList[i].etTag = true
                        this.tenantList[i].expireTime = ''
                    } else {
                        this.tenantList[i].expireTimeStr = etStr
                    }

                    if (this.tenantList[i].status == 0) {
                        this.tenantList[i].status = '禁用'
                    } else if (this.tenantList[i].status == 1) {
                        this.tenantList[i].status = '启用'
                    }
                }
            })
        },
        pageClick(currentPage) {
            // console.log('pageClick()')
            // console.log(currentPage)

            this.pageIndex = (currentPage - 1) * 10
            this.getAll()
        },
        permissionClick() {

            if (this.opCompanyId == '') {
                this.$message({
                    type: 'info',
                    message: '请选择租户'
                })
                return
            }

            this.$axios({
                method: "post",
                url: "/shiro/role/permission/imp",
                data: {
                    companyId: this.opCompanyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status == 201) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                }

            })
        }
    },
    mounted() {
        this.getAll()
    }
}
</script>

<style>
#order-header {
    height: 70px;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}
</style>